var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{ref:"editCampaignForm",attrs:{"edit-mode":true},on:{"updated":_vm.isUpdated}})}
var staticRenderFns = []

export { render, staticRenderFns }